"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.showTwo = void 0;
var bigdata_stat_1 = require("../bigdata_stat");
var two_html_1 = __importDefault(require("./two.html"));
/** 弹出三幅红包的推广 */
function showTwo(tgdata) {
    var eid = tgdata.eid;
    (0, bigdata_stat_1.sendStat)('DIV', 'Open', 'dfcfw.ggw.tc-xxs', { "eid": eid });
    // let img1 = new Image()
    // img1.src = tgdata.imgUrl[0]
    // img1.className = 'websitepoptg_img1'
    // let isLoaded1 = img1.complete && img1.naturalHeight !== 0;
    var img2 = new Image();
    img2.src = tgdata.imgUrl[0];
    img2.className = 'websitepoptg_img2';
    var isLoaded2 = img2.complete && img2.naturalHeight !== 0;
    var img3 = new Image();
    img3.src = tgdata.imgUrl[1];
    img3.className = 'websitepoptg_img3';
    var isLoaded3 = img3.complete && img3.naturalHeight !== 0;
    var div = document.createElement('div');
    div.className = 'websitepoptg_two';
    div.innerHTML = two_html_1["default"];
    // let websitepoptg_two_img_1 =  div.querySelector('.websitepoptg_two_img_1') as  HTMLDivElement
    var websitepoptg_two_img_2 = div.querySelector('.websitepoptg_two_img_2');
    var websitepoptg_two_img_3 = div.querySelector('.websitepoptg_two_img_3');
    var close = div.querySelector('.websitepoptg_two_close');
    // websitepoptg_two_img_1.appendChild(img1)
    websitepoptg_two_img_2.appendChild(img2);
    websitepoptg_two_img_3.appendChild(img3);
    // /** 有没有点过大红包 */
    // let clickHB = false
    // //打开红包
    // function openHB(){
    //   // websitepoptg_two_img_1.style.display = 'none'
    //   websitepoptg_two_img_2.style.display = 'block'
    //   websitepoptg_two_img_3.style.display = 'none'
    //   close.style.marginLeft = (getImgWidth(img2) / 2) + 'px'
    //   close.style.marginTop = (-(getImgHeight(img2) / 2) - 30) + 'px'    
    //   clickHB = true
    // }
    //小红包
    function smallHB() {
        // websitepoptg_two_img_1.style.display = 'none'
        websitepoptg_two_img_2.style.display = 'none';
        websitepoptg_two_img_3.style.display = 'block';
        close.style.display = 'none';
    }
    //恢复大红包
    function bigHB() {
        websitepoptg_two_img_2.style.display = 'block';
        websitepoptg_two_img_3.style.display = 'none';
        close.style.display = 'block';
    }
    /** 定位 */
    if (isLoaded2) {
        websitepoptg_two_img_2.style.marginLeft = (-(getImgWidth(img2) / 2)) + 'px';
        websitepoptg_two_img_2.style.marginTop = (-(getImgHeight(img2) / 2)) + 'px';
        close.style.marginLeft = (getImgWidth(img2) / 2) + 'px';
        close.style.marginTop = (-(getImgHeight(img2) / 2) - 30) + 'px';
    }
    else {
        img2.addEventListener('load', function () {
            websitepoptg_two_img_2.style.marginLeft = (-(getImgWidth(img2) / 2)) + 'px';
            websitepoptg_two_img_2.style.marginTop = (-(getImgHeight(img2) / 2)) + 'px';
            close.style.marginLeft = (getImgWidth(img2) / 2) + 'px';
            close.style.marginTop = (-(getImgHeight(img2) / 2) - 30) + 'px';
        });
    }
    // if(isLoaded2){
    //   // console.info('isLoaded2', getImgWidth(img2), getImgHeight(img2))
    //   websitepoptg_two_img_2.style.marginLeft = (-(getImgWidth(img2) / 2)) + 'px'
    //   websitepoptg_two_img_2.style.marginTop = (-(getImgHeight(img2) / 2)) + 'px'
    // }
    // else{
    //   // console.info('load2', getImgWidth(img2), getImgHeight(img2))
    //   if(getImgWidth(img2) > 0){
    //       websitepoptg_two_img_2.style.marginLeft = (-(getImgWidth(img2) / 2)) + 'px'
    //       websitepoptg_two_img_2.style.marginTop = (-(getImgHeight(img2) / 2)) + 'px'
    //   }
    //   else{
    //     img2.addEventListener('load', function(){
    //       // console.info('load22', getImgWidth(img2), getImgHeight(img2))
    //       websitepoptg_two_img_2.style.marginLeft = (-(getImgWidth(img2) / 2)) + 'px'
    //       websitepoptg_two_img_2.style.marginTop = (-(getImgHeight(img2) / 2)) + 'px'
    //     })        
    //   }
    // }
    if (isLoaded3) {
        websitepoptg_two_img_3.style.marginLeft = (-(getImgWidth(img3)) - 40) + 'px';
    }
    else {
        img3.addEventListener('load', function () {
            websitepoptg_two_img_3.style.marginLeft = (-(getImgWidth(img3)) - 40) + 'px';
        });
    }
    /** 事件 */
    close.addEventListener('click', function (e) {
        smallHB();
        (0, bigdata_stat_1.sendStat)('DIV', 'click', 'dfcfw.ggw.tcgb-xxs');
        e.stopPropagation();
    });
    // websitepoptg_two_img_1.addEventListener('click', function(){
    //   openHB()
    //   sendStat('DIV', 'click', 'dfcfw.ggw.hbdk')
    // })
    // document.addEventListener('click', function(e){
    //   try {
    //     let target = e.target as HTMLElement
    //     if(target && target.className != 'websitepoptg_two' && target.className != 'websitepoptg_img1' && target.className != 'websitepoptg_img2' && target.className != 'websitepoptg_img3'){
    //       smallHB()
    //       // sendStat('DIV', 'click', 'dfcfw.ggw.tcgb')  
    //       e.stopPropagation()
    //     }      
    //   } catch (error) {
    //   }
    // })
    // document.addEventListener("keydown", function(e) {
    //   try {
    //     smallHB()
    //     // sendStat('DIV', 'click', 'dfcfw.ggw.tcgb')    
    //   } catch (error) {
    //   }
    // });
    //拖动
    var mousedown = false;
    var mousemove = false;
    var down_x = 0;
    var down_y = 0;
    var move_x = 0;
    var move_y = 0;
    websitepoptg_two_img_3.addEventListener('mousedown', function (e) {
        mousedown = true;
        down_x = e.clientX;
        down_y = e.clientY;
        if (websitepoptg_two_img_3.style.transform) {
            var xy = websitepoptg_two_img_3.style.transform.match(/[-\d]+/g);
            if ((xy === null || xy === void 0 ? void 0 : xy.length) == 2) {
                move_x = parseInt(xy[0]);
                move_y = parseInt(xy[1]);
            }
        }
    });
    websitepoptg_two_img_3.addEventListener('click', function () {
        if (mousemove) {
            mousemove = false;
        }
        else {
            bigHB();
            (0, bigdata_stat_1.sendStat)('DIV', 'click', 'dfcfw.ggw.hbdj-xxs');
        }
    });
    document.body.addEventListener('mouseup', function (e) {
        mousedown = false;
    });
    document.body.addEventListener('mousemove', function (e) {
        if (!mousedown)
            return false;
        e.preventDefault();
        mousemove = true;
        var x = e.clientX;
        var y = e.clientY;
        websitepoptg_two_img_3.style.transform = "translate(".concat(x - down_x + move_x, "px, ").concat(y - down_y + move_y, "px)");
        //@ts-ignore IE9 fix
        websitepoptg_two_img_3.style.msTransform = "translate(".concat(x - down_x + move_x, "px, ").concat(y - down_y + move_y, "px)");
    });
    document.body.appendChild(div);
}
exports.showTwo = showTwo;
function getImgWidth(img) {
    if (img.naturalWidth) {
        return img.naturalWidth;
    }
    if (img.width) {
        return img.width;
    }
    return img.clientWidth;
}
function getImgHeight(img) {
    if (img.naturalHeight) {
        return img.naturalHeight;
    }
    if (img.height) {
        return img.height;
    }
    return img.clientHeight;
}
